import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=0db9e295&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=ts"
export * from "./FormComponent.vue?vue&type=script&lang=ts"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=0db9e295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9e295",
  null
  
)

export default component.exports